/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProductPositionInstallationReferenceFragmentDoc } from "../../building-references/graphql/fragments.generated"
import { ExternalDimensioningResultFragmentDoc } from "../../dim-configuration/graphql/external-dimensioning.fragments.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProductPositionFragment = {
  __typename: "ProductPosition"
  id: string
  label?: string | null
  variantKey: string
  configurationKey?: string | null
  remark?: string | null
  quantity: number
  position: number
  displayPosition?: string | null
  isAlternative?: boolean | null
  price?: number | null
  priceGroup?: string | null
  hasClarificationRequest?: boolean | null
  references?: Array<{
    __typename: "ProductPositionInstallationReference"
    id: string
    title?: string | null
    permalink: string
    position: number
  }> | null
  addons?: Array<{
    __typename: "ProductPositionAddon"
    id: string
    variantKey: string
    parentProductType: string
  }> | null
  dimensioning?: {
    __typename: "ExternalDimensioningResult"
    transactionId: string
    environmentalVars?: Array<any> | null
    variantKeyData?: any
    dllVersion?: string | null
    language?: string | null
    technicalData?: Array<
      | {
          __typename: "ExternalDimensioningTechnicalDataDllVersion"
          dllVersion: string
        }
      | {
          __typename: "ExternalDimensioningTechnicalDataTable"
          header?: Array<string> | null
          content?: any
          summary?: string | null
          type?: string | null
        }
    > | null
    technicalInput?: Array<{
      __typename: "ExternalDimensioningTechnicalInput"
      name: string
      label?: string | null
      unit?: string | null
      value?: any
      userSelected: boolean
    }> | null
    supplementaryText?: Array<{
      __typename: "ExternalDimensioningSupplementaryText"
      text: string
    }> | null
    transferData?: {
      __typename: "ExternalDimensioningTransferData"
      origin?: string | null
    } | null
  } | null
}

export type ProductPositionParentFragment = {
  __typename: "ProductPosition"
  parent?:
    | { __typename: "Project"; id: string; title: string }
    | { __typename: "Room"; id: string; label?: string | null; number: string }
    | null
}

export const ProductPositionFragmentDoc = gql`
  fragment ProductPosition on ProductPosition {
    id
    label
    variantKey
    configurationKey
    remark
    quantity
    position
    displayPosition
    isAlternative
    price
    priceGroup
    references @type(name: "ProductPositionInstallationReference") {
      ...ProductPositionInstallationReference
    }
    addons @type(name: "ProductPositionAddon") {
      id
      variantKey
      parentProductType
    }
    dimensioning @type(name: "ExternalDimensioningResult") {
      ...ExternalDimensioningResult
    }
    hasClarificationRequest
  }
  ${ProductPositionInstallationReferenceFragmentDoc}
  ${ExternalDimensioningResultFragmentDoc}
`
export const ProductPositionParentFragmentDoc = gql`
  fragment ProductPositionParent on ProductPosition {
    parent {
      ... on Project {
        id
        title
      }
      ... on Room {
        id
        label
        number
      }
    }
  }
`
